import { Component } from '@verndale/core';
import MicroModal from 'micromodal';
import Cookies from 'js-cookie';
import Axios from 'axios';
import { isValid } from '../components/eloqua-form';
import { dispatchGenericEvent } from '../utils/dispatch-events';
import { isTabletLandscapeUp } from '../utils/breakpoints';
import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.id = this.el.id;
    this.dom = {
      $closeButton: this.el._$('.eloqua-modal__close'),
      $overlay: this.el._$('.eloqua-modal__overlay'),
      $modal: this.el._$('.eloqua-modal__container'),
      $form: this.el.getElementsByTagName('form')[0],
      $text: this.el._$('.eloqua-modal__description'),
      $select: this.el._$$('select')
    };
  }

  addListeners() {
    const { $closeButton, $form } = this.dom;
    this.el._on(constEvent.OPEN_ELOQUA_MODAL, this.openModal.bind(this));
    this.el._on(constEvent.CLOSE_ELOQUA_MODAL, this.closeModal.bind(this));
    document._on('click', this.onModalTriggerClick.bind(this));
    $closeButton._on('click', () => {
      this.closeModal(this);
      dispatchGenericEvent(constEvent.CLOSED_ELOQUA_MODAL, {}, this.el);
    });
    $form._on('submit', this.handleSubmit.bind(this));
  }

  onModalTriggerClick(e) {
    const el = e.target.closest(`[data-micromodal-trigger="${this.id}"]`);
    if (!el) return;
    this.openModal();
  }

  openModal(e) {
    $('.eloqua-modal__overlay').removeAttr('data-eloqua-modal-close');
    $('.generic-modal__overlay').removeAttr('data-generic-modal-close');

    if (isTabletLandscapeUp) {
      document.body.style.overflow = 'hidden';
      this.updateContent(e?.detail);
    }

    MicroModal.show(this.id, {
      openClass: 'eloqua-modal--open'
    });
  }

  closeModal() {
    if (isTabletLandscapeUp) {
      document.body.style.overflow = '';
    }
    this.resetContent();
    MicroModal.close(this.id);
  }

  handleSubmit() {
    if (!isValid(this.dom.$form)) return;
    Cookies.set(this.el.dataset.cookieKey, this.el.dataset.cookieValue);
    if (this.el.dataset.redirectApi) Axios.get(this.el.dataset.redirectApi);
    this.closeModal();
    dispatchGenericEvent(constEvent.ELOQUA_FORM_SUMBITTED, { id: this.id })
  }

  updateContent(detail) {
    this.defaultRedirect = this.el.dataset.redirectApi;
    this.defaultText = this.dom.$text.textContent;

    if (detail?.url) {
      this.el.dataset.redirectApi = detail.url;
    }

    if (detail?.text) {
      this.dom.$text.textContent = detail.text;
    }
  }

  resetContent() {
    if (this.defaultRedirect) {
      this.el.dataset.redirectApi = this.defaultRedirect;
    }

    if (this.defaultText) {
      this.dom.$text.textContent = this.defaultText;
    }

    const $submit = this.dom.$form._$('.submit-button-style');

    if ($submit) {
      $submit.disabled = false;
      $submit.style.cursor = 'pointer';
    }
  }
}

export default Module;
